import { FC } from 'react'
import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import CustomComponentAreaCaseBySubmission from '../customComponentAreaCaseBySubmission';
import GeographicalStatistics from '../geographicalStatistics';
import { GeographicalStatisticsObject } from 'src/pages/manufacturer/types';
import { AllProductProps } from '../allProductsStats/types';
import DrillDownPieChart from '../drillDownPieChart';
const IoveraStats: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData, drug }): JSX.Element => {

  return (
    <div>
      {statisticsData && (
        <CaseFilter defaultQueryParams={queryParams} updateQueryParams={updateQueryParamsAndCallAPI} drug={drug} />
      )}
      {statisticsData && queryParams && (
        <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
          buttonShows={true} showPractice={true} drug={drug} />
      )}

      <div className='row'>
          <div className="col-12 col-lg-6">
              {statisticsData &&
                  <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />
              }
          </div>
          {/* <div className="col-12 col-lg-6">
              {statisticsData && statisticsData.data &&
                  <CustomPieChart title="Top 10 Payors Requiring PA" pieChartObject={statisticsData.data.top_pa_payors} />
              }
          </div> */}
          <div className="col-12 col-lg-6">
              {statisticsData && statisticsData.data &&
                <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
              }
          </div>
          <div className="col-12 col-lg-12">
              {statisticsData && statisticsData.data &&
                  <DrillDownPieChart pieChartObject={statisticsData.data.icd_iovera_data} title={'Top 10 ICD Codes'} />
              }
          </div>
          {statisticsData && queryParams && (
              <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={'Areas'} drug={drug} isFullRow />
          )}
      </div>


      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
    </div>
  )
}
export default IoveraStats;